import { detect, track, isEnabled } from "@otto-ec/global-mpathy";

/*🤫*/
/*🤫*/
detect(window.navigator.userAgent);

/*🤫*/
window.o_global = window.o_global || {};
window.o_global.mpathy = window.o_global.mpathy || { track, isEnabled };
